module.exports = __webpack_public_path__ + "static/img/zp1.3d8b1d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/zp1.png
// module id = SAig
// module chunks = 1